'use client';

import { useEffect, useState } from 'react';
import Script from 'next/script';

const GA_ID = 'G-GCSEBLPGX1';

export default function DeferredAnalytics() {
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    if (shouldLoad) return undefined;

    const activate = () => {
      setShouldLoad(true);
    };

    const events: Array<keyof WindowEventMap> = ['pointerdown', 'touchstart', 'keydown', 'scroll'];
    events.forEach(eventName => {
      window.addEventListener(eventName, activate, { passive: true, once: true });
    });

    const idleId =
      typeof window.requestIdleCallback === 'function'
        ? window.requestIdleCallback(activate, { timeout: 5000 })
        : window.setTimeout(activate, 5000);

    return () => {
      events.forEach(eventName => {
        window.removeEventListener(eventName, activate);
      });

      if (typeof window.cancelIdleCallback === 'function' && typeof idleId === 'number') {
        window.cancelIdleCallback(idleId);
      } else {
        window.clearTimeout(idleId as number);
      }
    };
  }, [shouldLoad]);

  if (!shouldLoad) return null;

  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${GA_ID}`}
        strategy="afterInteractive"
      />
      <Script id="lytra-google-analytics" strategy="afterInteractive">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${GA_ID}');
        `}
      </Script>
    </>
  );
}
